import { action, computed, makeObservable, onBecomeObserved } from "mobx"

import { GlobalCurrenciesCollection } from "@src/app/CurrenciesCollection"
import { TransactionsDepositsCollectionFilters } from "@src/pages/transactionsDeposits/constants"
import { catchErrors, depositsApi } from "@src/shared/api"
import {
  DepositPaymentResponse,
  NetworkCrypto,
  Pagination,
  SymbolCrypto,
} from "@src/shared/api/generated"
import { CollectionWithPagination } from "@src/shared/classes/Collection/CollectionWithPagination"
import { loading } from "@src/shared/classes/utils/loading"
import { CollectionFilters } from "@src/shared/componemts/TableFilter/classes/CollectionFilters"

export type TransactionsDepositsLoadRequest = {
  address?: string
  amlLevel?: "high" | "low" | "medium"
  depositId?: string
  id?: string
  network?: NetworkCrypto
  order?: "asc" | "desc"
  page?: number
  status?: "confirmed" | "failed" | "pending"
  symbol?: SymbolCrypto
  txId?: string
}
export type TransactionsDepositsCollectionFiltersType = {
  order?: "asc" | "desc"
  status?: "failed" | "pending" | "success"
}

export type DepositPayment = Required<DepositPaymentResponse> & {
  tx_explorer_url?: string
}
export class TransactionsDepositsCollection extends loading(
  ["fetch"],
  CollectionWithPagination<DepositPayment>,
) {
  private _currencies = GlobalCurrenciesCollection()

  constructor() {
    super()

    makeObservable(this, {
      fetch: action.bound,
      networks: computed,
      symbols: computed,
    })

    onBecomeObserved(this, "isLoading", this.load)
  }

  async fetch(req: TransactionsDepositsLoadRequest): Promise<{
    data: DepositPayment[]
    pagination: Pagination
  } | null> {
    try {
      const {
        data: { data: { data, pagination } = {} },
      } = await depositsApi.getDepositsPayments(
        this.order,
        this.calcOffset(req.page),
        this.pageSize,
        req.id,
        req.depositId,
        req.address,
        undefined,
        req.txId,
        req.network,
        req.symbol,
        req.status,
        req.amlLevel,
      )

      if (data && pagination) {
        return {
          data: data as DepositPayment[],
          pagination,
        }
      }
    } catch (e: any) {
      catchErrors(e)
    }

    return null
  }

  get filter() {
    return new CollectionFilters<TransactionsDepositsCollectionFiltersType>(
      [
        ...TransactionsDepositsCollectionFilters,
        CollectionFilters.createField("network").select(this.networks, {
          col: 6,
          label: "Network",
          placeholder: "Select a network",
        }),

        CollectionFilters.createField("symbol").select(this.symbols, {
          col: 6,
          label: "Symbol",
          placeholder: "Select a symbol",
        }),
      ],
      this.load,
    )
  }

  get networks() {
    return this._currencies.cryptoNetworks.map((i) => ({
      label: i,
      value: i,
    }))
  }

  get symbols() {
    // return [
    //   ...new Set(
    //     this._currencies.crypto.map((i) => `${i.symbol}_${i.symbol_alias}`),
    //   ),
    // ].reduce((acc: Record<string, any>[], i) => {
    //   const [symbol, symbol_alias] = i.split("_")
    //   const alreadyHas = acc.some((i) => i.value === symbol_alias)
    //
    //   if (!alreadyHas) {
    //     acc.push({
    //       key: `${symbol}_${symbol_alias}`,
    //       label: symbol_alias,
    //       value: symbol_alias,
    //     })
    //   }
    //
    //   return acc
    // }, [])

    return [...new Set(this._currencies.crypto.map((i) => i.symbol))].map(
      (i) => ({ label: i, value: i }),
    )
  }
}
